<template>
  <div>
    <top-bar heading="Gallery"></top-bar>
    <loading-spinner :loading="!loaded"></loading-spinner>
    <div class="container-fluid mt-3" v-if="loaded">
      <b-card class="p-3">
        <div class="row mb-3">
          <div class="col">
            <label class="control-label visible-ie8 visible-ie9" for="project_name">Project Name</label>
            <input
                    :class="{'form-control': true, 'is-invalid': errors.has('project_name')}"
                    v-validate="'required'"
                    data-vv-delay="500"
                    data-vv-as="Project Name"
                    data-vv-name="project_name"
                    type="text"
                    placeholder="Project Name"
                    name="project_name"
                    id="project_name"
                    v-model="gallery.project_name"/>
            <div class="invalid-tooltip d-block" v-if="errors.has('project_name')">{{ errors.first('project_name') }}</div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col">
            <label class="control-label visible-ie8 visible-ie9" for="job_notes">Job Notes</label>
            <vue-editor :class="{'is-invalid': errors.has('job_notes')}"
                        v-validate="'required'"
                        data-vv-delay="500"
                        data-vv-as="Job Notes"
                        data-vv-name="job_notes"
                        type="textarea"
                        placeholder="Job Notes"
                        name="job_notes"
                        id="job_notes"
                        v-model="gallery.notes"></vue-editor>
            <div class="invalid-tooltip d-block" v-if="errors.has('job_notes')">{{ errors.first('job_notes') }}</div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col">
            <loading-button :loading="loading" @submit="save" block>Save Gallery</loading-button>
          </div>
        </div>
      </b-card>
      <b-card class="p-3">
        <div class="row">
          <div class="col-6 col-md-4 col-xl-2 h-100 evidence-img p-1" v-for="image in gallery.images" :key="image.id">
            <div class="delete-img" @click.stop="removeImage(image)">
              <font-awesome-icon icon="times-circle"></font-awesome-icon>
            </div>
            <b-img :src="image.url" fluid thumbnail height="450px" v-if="!image.srcSet"></b-img>
            <img :src="image.placeholder" :alt="image.file_name" :srcset="image.srcSet"  class="img-fluid img-thumbnail" v-else />
            <!--<img :src="file.url" :alt="file.file_name" class="img-fluid" >-->
            <!--<img :src="file.placeholder" :srcset="file.srcSet" :alt="file.file_name" class="img-fluid" v-if="file.srcSet">-->
          </div>
        </div>
      </b-card>
      <b-card class="p-3">
        <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" v-on:vdropzone-success="mediaUploaded"></vue-dropzone>
      </b-card>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';

export default {
  name: 'EvidenceGallery',
  components: {
    vueDropzone: vue2Dropzone
  },
  data () {
    return {
      gallery: {},
      loaded: false,
      loading: false
    };
  },
  computed: {
    dropzoneOptions () {
      return {
        url: this.$config.API_URL + '/evidence_gallery/' + this.id + '/upload',
        //thumbnailWidth: 150,
        //maxFilesize: 20000,
        acceptedFiles: 'image/*',
        headers: {'Authorization': 'Bearer ' + this.$auth.token()},
        dictDefaultMessage: `
          <div class="text-center text-black-50">
            <i class="icon-cloud-upload" style="font-size: 5em"></i>
            <h4 class="mt-2 mb-1">Drag & Drop a File</h4>
            <h6 class="ui-font-Montserrat-Regular">Or select an option below</h6>
            <div class="drag_add">
              <span class="btn btn-primary">Add Image</span>
            </div>
          </div>
        `
      };
    }
  },
  methods: {
    save () {
      this.loading = true;
      this.axios.put('/evidence_gallery/' + this.id, this.gallery).then(rsp => {
        this.gallery = rsp.data.data;
        this.$snotify.success('Gallery Updated');
        this.loading = false;
      }).catch(err => this.$errorOut(err));
    },
    mediaUploaded (file, rsp) {
      this.gallery.images.push(rsp.data);

      this.$refs.myVueDropzone.removeFile(file);
    },
    removeImage (image) {
      this.axios.delete('/evidence_gallery/' + this.id + '/image/' + image.id).then(() => {
        this.gallery.images.splice(this.gallery.images.findIndex(x => x.id === image.id), 1);
        this.$snotify.success('Image Deleted');
      }).catch(err => this.$errorOut(err));
    }
  },
  mounted () {
    this.axios.get('/evidence_gallery/' + this.id).then(rsp => {
      this.loaded = true;
      this.gallery = rsp.data.data;
    });
  },
  metaInfo: {
    title: 'Gallery'
  },
  props: ['id']
};
</script>

<style lang="scss">
  @import "~vue2-dropzone/dist/vue2Dropzone.min.css";
  @import "../../assets/scss/colour";

  .evidence-img {
    position: relative;

    .delete-img {
      position: absolute;
      top: -10px;
      right: 7px;
      z-index: 100;
      color: $red;

      &:hover {
        cursor: pointer;
        color: lighten($red, 10%);
      }
    }
  }
</style>